import { SVGProps } from "react";

const Wheel = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
		<g>
			<g>
				<path d="M256.001,0C114.841,0,0,114.841,0,255.999S114.841,512,256.001,512S512,397.159,512,255.999S397.159,0,256.001,0z
					M256.001,478.824c-122.866,0-222.824-99.958-222.824-222.824S133.134,33.176,256.001,33.176s222.824,99.958,222.824,222.823
					S378.866,478.824,256.001,478.824z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M256.001,82.941c-95.41,0-173.06,77.638-173.06,173.059c0,95.255,77.464,173.06,173.06,173.06
					c95.653,0,173.059-77.871,173.059-173.06C429.059,160.8,351.603,82.941,256.001,82.941z M301.341,123.664
					c17.279,5.937,33.04,15.167,46.529,26.94l-33.04,19.075c-2.73,1.576-6.261,1.576-8.993,0c-2.774-1.601-4.495-4.585-4.495-7.788
					V123.664z M210.659,123.665v38.228c0,3.203-1.723,6.186-4.497,7.788c-2.73,1.577-6.263,1.577-8.992,0l-33.04-19.075
					C177.619,138.832,193.379,129.601,210.659,123.665z M116.117,255.999c0-9.2,0.902-18.193,2.607-26.902l33.107,19.114
					c2.774,1.601,4.495,4.585,4.495,7.788c0,3.203-1.723,6.187-4.497,7.789l-33.107,19.113
					C117.019,274.192,116.117,265.2,116.117,255.999z M210.659,388.336c-17.279-5.937-33.038-15.167-46.528-26.94l33.04-19.076
					c2.729-1.575,6.258-1.577,8.992,0.002c2.774,1.6,4.495,4.585,4.495,7.786V388.336z M301.34,388.336v-38.228
					c0-3.203,1.723-6.186,4.498-7.789c2.73-1.575,6.259-1.575,8.991,0.001l33.04,19.075
					C334.381,373.169,318.62,382.399,301.34,388.336z M382.67,315.305c-3.3,7.029-7.312,14.046-12.113,20.873
					c-0.001,0.002-0.002,0.003-0.004,0.006l-39.134-22.594c-13.054-7.54-29.143-7.525-42.169-0.001
					c-13.006,7.508-21.085,21.5-21.085,36.518v45.24c-3.688,0.323-7.783,0.523-11.866,0.531c-0.199,0-0.398,0-0.598,0
					c-3.869-0.009-7.981-0.191-11.866-0.531v-45.24c0-15.018-8.08-29.01-21.082-36.517c-13.055-7.54-29.143-7.525-42.17-0.001
					l-39.136,22.595c-0.001-0.002-0.002-0.003-0.004-0.006c-4.838-6.881-8.796-13.808-12.192-21.046l39.169-22.613
					c13.005-7.51,21.084-21.503,21.084-36.519c0-15.018-8.08-29.01-21.085-36.518l-39.168-22.613
					c3.335-7.169,7.485-14.348,12.191-21.044c0.002-0.002,0.003-0.005,0.005-0.008l39.136,22.595c13.033,7.524,29.116,7.535,42.168,0
					c13.006-7.508,21.085-21.5,21.085-36.518v-45.24c3.646-0.323,7.868-0.523,11.869-0.531c0.197,0,0.394,0,0.591,0
					c4.039,0.009,8.259,0.212,11.869,0.531v45.24c0,15.018,8.08,29.01,21.085,36.518c13.034,7.524,29.116,7.535,42.168,0
					l39.136-22.595c4.72,6.743,8.796,13.741,12.197,21.052l-39.187,22.624c-12.998,7.505-21.069,21.503-21.061,36.532
					c0.008,15.009,8.087,28.995,21.084,36.498l39.164,22.611C382.723,315.19,382.696,315.248,382.67,315.305z M360.174,263.79
					c-2.771-1.6-4.494-4.584-4.495-7.784c-0.001-3.207,1.712-6.19,4.473-7.783l33.125-19.125c1.703,8.709,2.607,17.702,2.607,26.902
					s-0.902,18.193-2.607,26.902L360.174,263.79z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M256.001,201.866c-29.85,0-54.135,24.284-54.135,54.134c0,29.85,24.284,54.135,54.135,54.135s54.135-24.285,54.135-54.135
					C310.135,226.15,285.85,201.866,256.001,201.866z M256.001,276.958c-11.556,0-20.959-9.402-20.959-20.959
					s9.401-20.957,20.959-20.957s20.959,9.401,20.959,20.957S267.557,276.958,256.001,276.958z"/>
			</g>
		</g>
    </svg>
  );
};

export default Wheel;
